import { memo } from "react";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { useVoucherI18nName } from "./hooks";

export const QuestionVoucherName = memo(() => {
	const { name, onSetName } = useVoucherI18nName();

	return (
		<QuestionForMain
			required={true}
			title="宿泊券名"
			guide="宿泊券の内容が伝わるシンプルな名前にしましょう。"
			inputChildren={<InputTextField errorMessage={name.error} value={name.value} handleChange={onSetName} />}
		/>
	);
});

QuestionVoucherName.displayName = "QuestionVoucherName";
